/*
 * fn: isInColorId
 *
 * Takes a needle and haystack Color ID and returns if the needle is valid within the haystack
 *
 */
import { COLOR_ID_LABELS, type ColorIdType } from '@/defs/mtg'

export const isInColorId = (needle: ColorIdType, haystack: ColorIdType) =>
  needle === 'colorless' || COLOR_ID_LABELS[needle].colors.every((c) => COLOR_ID_LABELS[haystack].colors.includes(c))
